__webpack_require__.p = "//web.webstatic.cc/web/equity/_next/";